<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>Can I change my decision later?<Caret /></summary>
  <p>
    Once you make your decision, it will be <b>final</b>, since our team will need to take action ASAP on your
    behalf to continue the process as quickly as possible. Please take your time in making your decision.
  </p>
</details>
